export function isTagEditable(tag: Tag) {
  return !tag.external;
};